import React from 'react';

const Pointer = () => <div className="pointer" />;

export default Pointer;
